import { Dispatch, FC, SetStateAction, useState } from 'react';

import SettingsIcon from '@mui/icons-material/Settings';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from '@mui/x-data-grid-pro';

type TableSettingsProps = {
  setAnchor: Dispatch<SetStateAction<HTMLElement | null>>;
};

const TableSettings: FC<TableSettingsProps> = ({ setAnchor }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton size='small' onClick={(e) => setAnchorEl(e.currentTarget)}>
        <SettingsIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        id='table-settings-menu'
        open={open}
        onClose={() => setAnchorEl(null)}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              'overflow': 'visible',
              'filter': 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              'mt': 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <GridToolbarColumnsButton
          ref={setAnchor}
          component={MenuItem}
          sx={{
            width: '100%',
            color: 'text.secondary',
            borderRadius: 0,
            justifyContent: 'flex-start',
            px: 2,
            py: 1,
          }}
        />
        <GridToolbarDensitySelector
          component={MenuItem}
          sx={{
            width: '100%',
            color: 'text.secondary',
            borderRadius: 0,
            justifyContent: 'flex-start',
            px: 2,
            py: 1,
          }}
        />
        <Divider />
        <GridToolbarExport
          component={MenuItem}
          sx={{
            width: '100%',
            color: 'text.secondary',
            borderRadius: 0,
            justifyContent: 'flex-start',
            px: 2,
            py: 1,
          }}
        />
      </Menu>
    </>
  );
};

export default TableSettings;
